/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/* eslint-disable no-duplicate-imports */
import { Module, Node, Waiting } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';
import * as Msdyn365 from '@msdyn365-commerce/core';

import { IBusinessSignUpItem, IBusinessSignUpViewProps } from './krannich-c-business-sign-up';
import { IKrannichCBusinessSignUpProps } from './krannich-c-business-sign-up.props.autogenerated';
import { IContentBlockConfig } from '../../themes/krannich/definition-extensions/content-block.ext.props.autogenerated';

const BusinessSignUpItem: React.FC<IBusinessSignUpItem> = ({ wrapper, label, errorMessage, input, isAddressInput }) => {
    // Hide label and error message if rendering address section
    return (
        <Node {...wrapper}>
            {!isAddressInput && label}
            {!isAddressInput && errorMessage}
            {input}
        </Node>
    );
};

const BusinesSignUpView: React.FC<IBusinessSignUpViewProps & IKrannichCBusinessSignUpProps<{}>> = props => {
    const {
        businessSignUp,
        ContainerWrapper,
        heading,
        businessSignUpForm,
        resources,
        config: { bannerImage },
        context: {
            actionContext: {
                requestContext: {
                    user: { isAuthenticated, signInUrl }
                }
            },
            request: { gridSettings },
            actionContext: { requestContext }
        },
        termsConditions,
        newsletter
    } = props;
    //VSI Customization to add banner image from config for new design implementation
    const imageProps = {
        gridSettings: gridSettings ?? {},
        imageSettings: bannerImage?.imageSettings
    };

    interface IContentBlockFullConfig extends IContentBlockConfig {
        // eslint-disable-next-line @typescript-eslint/naming-convention -- This field comes from SDK.
        msdyn365__moduleLayout?: string;
    }
    const contentBlockImage = (
        <Msdyn365.Image
            {...bannerImage}
            {...imageProps}
            requestContext={requestContext}
            editProps={{
                key: bannerImage ?? {},
                requestContext: requestContext,
                // moduleType: typeName,
                imagePropertyName: 'image',
                // moduleId: props.id,
                layout: (bannerImage as IContentBlockConfig) && (bannerImage as IContentBlockFullConfig).msdyn365__moduleLayout
            }}
            shouldSkipToMainImage
        />
    );
    //VSI Customization to add banner image for new design implementation -- END

    const { FormWrapper, buttons, items, errorMessage, disclaimer } = businessSignUpForm;
    const { currentRegionName, ounRegions } = props.context?.app.config;
    const currentRegion = ounRegions?.find((region: { Name: any }) => region.Name === currentRegionName);

    return isAuthenticated ? (
        <Waiting />
    ) : (
        <div className='partner-signup-form-wrapper'>
            <p className='abn-info-text'>
                {items && currentRegion?.oun && props?.context?.actionContext?.requestContext?.apiSettings?.oun === currentRegion?.oun
                    ? resources.textForMexicoField
                    : props?.context?.actionContext?.requestContext?.apiSettings?.oun !== props.context.app.config.ounNumberForUsSite &&
                      resources.textUnderABNField}
            </p>
            <div className='prospect-status-message'>{props.getStatusMessage}</div>
            <div className='business-sign-up-form'>
                <Module {...businessSignUp}>
                    <Node {...ContainerWrapper}>
                        {heading}
                        <Node {...FormWrapper}>
                            {items &&
                                items.map((item: IBusinessSignUpItem) => {
                                    return <BusinessSignUpItem key={item.id} {...item} />;
                                })}
                            {errorMessage &&
                                errorMessage.map((error: React.ReactNode, index: number) => {
                                    return <React.Fragment key={index}>{error}</React.Fragment>;
                                })}
                            {/* {VSI customization to add check boxes for newsletter, terms & conditions link from config} */}
                            {newsletter}
                            {termsConditions}
                            {buttons &&
                                buttons.map((button: React.ReactNode, index: number) => {
                                    return <React.Fragment key={index}>{button}</React.Fragment>;
                                })}
                            {disclaimer}
                            {
                                <div className='b2b-sign-up-btn'>
                                    <span>{resources.alreadyHaveAnAccount} </span>
                                    {signInUrl && (
                                        <a className='header-sign-in-button' href={signInUrl}>
                                            {resources.signInLink}
                                        </a>
                                    )}
                                </div>
                            }
                        </Node>
                    </Node>
                </Module>
            </div>
            <div className='order-details-bannerImage'>{contentBlockImage}</div>
        </div>
    );
};

export default BusinesSignUpView;
